import styled from 'styled-components';
import { BodyCopyVanilla } from '../../../../../../common/atoms/BodyCopy/views/BodyCopy';

export const StyledCheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
  ${({ disabled }) => (disabled ? 'text-decoration: line-through' : '')};
  width: 150px;
  font-family: 'Nunito';
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

export const StyledCheckbox = styled.span`
  width: 19px;
  height: 19px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: 4px;
  margin-right: 8px;
  border: 1px solid ${({ theme }) => theme.colors.BLACK};
  position: relative;
  transition: background-color 0.2s;
  ${HiddenCheckbox}:checked + & {
    background-color: ${({ theme }) => theme.colors.BLACK};
  }

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 11px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  ${HiddenCheckbox}:checked + &:after {
    display: block;
  }
`;

export const StyledCheckboxLabel = styled(BodyCopyVanilla)`
  font-size: 12px;
  font-weight: 400;
`;
